import { useEffect, useState } from "react";
import dayjs from "dayjs";

const useDelivery = ({ formik, storeState, setStoreState }) => {
  const [enabledDays, setEnabledDays] = useState({});
  const [time, setTime] = useState({
    from: {},
    to: {},
  });

  const handleCloseModal = () => {
    setStoreState((prev) => ({
      ...prev,
      showCreateModal: !prev.showCreateModal,
      isEdit: false,
    }));
  };

  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  useEffect(() => {
    if (formik.values.office_delivery !== 1) {
      formik.setFieldValue("office_delivery_hours", {});
      setStoreState((prev) => ({
        ...prev,
        curbTimeError: {},
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.office_delivery]);

  useEffect(() => {
    // Extract values from formik and set in the time state
    const extractedTime = {};

    daysOfWeek?.forEach((day) => {
      if (
        formik?.values?.office_delivery_hours &&
        formik?.values?.office_delivery_hours[day]
      ) {
        extractedTime[day] = {
          from: dayjs(
            formik?.values?.office_delivery_hours[day]?.from,
            "h:mm A",
          ),
          to: dayjs(formik?.values?.office_delivery_hours[day]?.to, "h:mm A"),
        };
      } else {
        extractedTime[day] = {
          from: null,
          to: null,
        };
      }
    });

    setTime(extractedTime);

    // Enable toggles for days with a time, otherwise disable
    const enabledDaysFromExtractedTime = {};
    daysOfWeek.forEach((day) => {
      enabledDaysFromExtractedTime[day] =
        !!extractedTime[day]?.from && !!extractedTime[day]?.to;
    });
    setEnabledDays(enabledDaysFromExtractedTime);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.office_delivery_hours]);

  const handleTimeChange = (day, type, newValue) => {
    const updatedTimeState = { ...time };
    updatedTimeState[day][type] = newValue;

    if (updatedTimeState[day].from && updatedTimeState[day].to) {
      const fromTime = updatedTimeState[day].from;
      const toTime = updatedTimeState[day].to;

      // Check if "to" time is at least 1 hour after "from" time
      const timeDifferenceInMinutes = toTime.diff(fromTime, "minutes");
      const isError = timeDifferenceInMinutes < 60;

      const updatedDeliveryHours = {
        ...formik?.values.office_delivery_hours,
        [day]: {
          from: fromTime.format("h:mm A"),
          to: toTime.format("h:mm A"),
        },
      };

      formik.setFieldValue("office_delivery_hours", updatedDeliveryHours);
    }

    setTime(updatedTimeState);
  };

  const handleToggle = (day) => {
    setEnabledDays((prevEnabledDays) => {
      const updatedEnabledDays = {
        ...prevEnabledDays,
        [day]: !prevEnabledDays[day],
      };

      // Remove day and its time if toggle is disabled
      if (!updatedEnabledDays[day]) {
        const updatedDeliveryHours = {
          ...formik?.values.office_delivery_hours,
        };
        delete updatedDeliveryHours[day];
        formik.setFieldValue("office_delivery_hours", updatedDeliveryHours);
      }

      return updatedEnabledDays;
    });
  };

  const getMinToTime = (day, fromTime) => {
    if (fromTime) {
      return fromTime.add(1, "hour");
    }
    return null;
  };
  const handleNext = () => {
    setStoreState((prev) => ({
      ...prev,
      activeTab: "Gate Delivery Hours",
    }));
  };
  return {
    time,
    daysOfWeek,
    enabledDays,
    handleNext,
    handleCloseModal,
    handleTimeChange,
    handleToggle,
    getMinToTime,
  };
};
export default useDelivery;
